/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Anlasskommentarelternkontakt2Inputs */

const de__field_anlasskommentarelternkontakt2 = /** @type {(inputs: _Field_Anlasskommentarelternkontakt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlasskommentar Elternkontakt`)
};

/**

* @param {_Field_Anlasskommentarelternkontakt2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_anlasskommentarelternkontakt2 = /** @type {((inputs?: _Field_Anlasskommentarelternkontakt2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Anlasskommentarelternkontakt2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_anlasskommentarelternkontakt2(inputs)
});
export { _field_anlasskommentarelternkontakt2 as "_field_anlassKommentarElternkontakt" }